require('./selectric');


  console.log('ada.js loaded');
$('select').selectric();

// var selectricBaseOptions = {
//   disableOnMobile: false,
//   onInit: function(select, selectric) {
//     return;
//     var uniqBaseId = select.id;
//     var $input = $(selectric.elements.input);
//     var $labelContainer = $(selectric.elements.label);
//     var $selectricList = $(selectric.elements.items);

//     // add id for current ".selectric-items" list
//     $selectricList.attr({
//       "id": "sl-" + uniqBaseId,
//       "tab-index": "-1",
//       "role": "listbox",
//       "aria-expanded": "false"
//     });
//     $selectricList.find('li').attr({
//       "role": "option"
//     });

//     $input.attr({
//       "role": "combobox",
//       "aria-owns": $selectricList.attr('id')
//     });

//     //$(element).closest('.selectric-wrapper').find('.selectric-input').attr('id', element[0].text);

//     $labelContainer.attr({
//       "aria-live": "assertive",
//       "aria-atomic": "true"
//     });
//   }
// };

// // Only initialize Selectric on selects that don't opt out (e.g. native multi-selects)
// $('select').each(function() {
//   var $select = $(this);
//   if ($select.attr('data-selectric') === 'false') {
//     return; // skip – use native select (required for multi-select; this plugin doesn't support it)
//   }
//   var options = $.extend(true, {}, selectricBaseOptions);
//   var dataOpts = $select.attr('data-selectric-options');

//   if (dataOpts) {
//     try {
//       var parsed = typeof dataOpts === 'string' ? JSON.parse(dataOpts) : dataOpts;
//       if (parsed && typeof parsed === 'object') {
//         $.extend(true, options, parsed);
//       }
//     } catch (e) {
//       // ignore invalid JSON
//     }
//   }

//   $select.selectric(options);
// });

// $('select').on('selectric-highlight', function(event, element, selectric) {
//   //debugger;
//   jQuery.each(selectric.items, function(index, item) {
//     // do something with `item` (or `this` is also `item` if you like)
//     if (item.selected) {
//       item.element.focus();
//       return;
//     }
//   });
// });

// // Close any open Selectric dropdown when clicking outside
// $(document).on('click', function(e) {
//   if (!$(e.target).closest('.selectric-wrapper').length) {
//     $('select').each(function() {
//       if ($(this).data('selectric')) {
//         $(this).selectric('close');
//       }
//     });
//   }
// });

// $(".selectric-input").attr('tabindex','-1').wrap("<label class='sr-only' aria-hidden='true'>Hidden Label</label>");